/* 
 * Développé par la société Précurseur.
 @copyright  Copyright (c) Précurseur
 @link       https://www.precurseur.fr
 */
import $ from 'jquery';


/**
 * repositionne le cart du footer extranet responsive
 */
export default class FooterMiniCart {

    constructor() {
        
        this.miniCartWrapper = $('#footer-adherent .elementor-menu-cart--cart-type-mini-cart');

        var observer = new MutationObserver(function (mutations) {
            for (var mutation of mutations) {            

                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    if ($(mutation.target).hasClass('elementor-menu-cart--shown')) {
                        var footerHeight = $('#footer-adherent').height();
                        var cartHeight = $('#footer-adherent .elementor-menu-cart__main').height();
                        var positionTop = footerHeight + cartHeight;

                        $('#footer-adherent .elementor-menu-cart__container').css('top', -positionTop);
                    }
                }
            }
        });

        if (this.miniCartWrapper.length > 0) {
            observer.observe(this.miniCartWrapper[0], {
                attributes: true
            });
        }
    }    
};
